export default "__VITE_PUBLIC_ASSET__e54b8a73__"